module.exports = function() {
  return new Worker("/" + "21c2a20b58cb04bf9bb8.worker.js");
};